import styled from "styled-components";

export { AppAuthenticationWrapper } from "~/Auth/AppAuthenticationWrapper";
export {
  getAuth0ApplicationConfiguration,
  Auth0ApplicationConfigurationType,
} from "~/Auth/Config";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 0 auto;
  padding: 2vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;
